import api from './api';

const service = {
    async searchResourceConfig(params) {
      return await api.get(`/aggregators/${params.aggregator_id}/low-actual-data-download/resources`, { params });
    },
    async downloadResource(params) {
      return await api.get(`/files/csv/aggregators/${params.aggregator_id}/low-actual-data-download/resources/${params.resource_id}`,{ params, responseType:'blob', dataType:'binary' });
    },
    async downloadActualData(params) {
      return await api.get(`/files/csv/aggregators/${params.aggregator_id}/low-actual-data-download/actual/${params.resource_id}`,{ params, responseType:'blob', dataType:'binary' });
    },
}

export default service;